import React, { useEffect, useState } from 'react';
import { Button } from '@fluentui/react-components';
import PractitionerConsumptionItemFilterComponent from './PractitionerConsumption.Item.Filter.Component';
import './PractitionerConsumption.Filter.Styles.css';
import { IConsumptionsFilters } from '../../../../../models/Filters/ConsumptionsFilters';
import PractitionerFilterPanelComponent from './PractitionerFilterPanel/PraFilterPanelComponent';

// TODO: Replace with your actual filter state type
export interface IPractitionerConsumptionsFilters {
  FilterText: string;
  SelectedProtocols: any[];
  SelectedCurrency: string;
  SelectedStatus: any[];
  SelectedDateRange: [Date | undefined, Date | undefined];
}

interface Props {
  filterText: string;
  setFilterText: (text: string | undefined) => void;
  selectedProtocols: any[];
  setSelectedProtocols: (protocols: any[]) => void;
  selectedCurrency: string;
  setSelectedCurrency: (currency: string) => void;
  selectedStatus: any[];
  setSelectedStatus: (status: any[]) => void;
  selectedDateRange: [Date | undefined, Date | undefined];
  setSelectedDateRange: (dateRange: [Date | undefined, Date | undefined]) => void;
  onChangeFilters: (filters: IConsumptionsFilters) => void;
}

const PractitionerConsumptionFilterComponent = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  // Compose a filter state object for panel
  const filterProps: IConsumptionsFilters = {
    FilterText: props.filterText,
    SelectedProtocols: props.selectedProtocols,
    SelectedCurrencys: props.selectedCurrency,
    SelectedStatus: props.selectedStatus,
    SelectedDateRange: props.selectedDateRange,
    SelectedConsumptions: [],
    SelectedProtocolPatients: [],
    SelectedContractConcepts: [],
    SelectedContractStages: [],
    SelectedPractitioners: [],
    SelectedSettlements: [],
    showGroupedByVisit: false,
    GroupId: undefined,
  };

  const onClearCriteria = (criteriaName: string) => {
    switch (criteriaName) {
      case 'Texto':
        props.setFilterText('');
        break;
      case 'Protocolos':
        props.setSelectedProtocols([]);
        break;
      case 'Monedas':
        props.setSelectedCurrency('');
        break;
      case 'Estado':
        props.setSelectedStatus([]);
        break;
      case 'Fecha desde':
        props.setSelectedDateRange([undefined, props.selectedDateRange[1]]);
        break;
      case 'Fecha hasta':
        props.setSelectedDateRange([props.selectedDateRange[0], undefined]);
        break;
      default:
        break;
    }
  };

  return (
    <div className="consumption-list-filter">
      <div className="filter-criteria-container">
        {props.filterText && (
          <PractitionerConsumptionItemFilterComponent
            criteriaName="Texto"
            criteria={[props.filterText]}
            onClearCriteria={onClearCriteria}
          />
        )}
        {props.selectedProtocols.length > 0 && (
          <PractitionerConsumptionItemFilterComponent
            criteriaName="Protocolos"
            criteria={props.selectedProtocols.map((p) => p.title || p.id)}
            onClearCriteria={onClearCriteria}
          />
        )}
        {props.selectedCurrency && (
          <PractitionerConsumptionItemFilterComponent
            criteriaName="Monedas"
            criteria={[props.selectedCurrency]}
            onClearCriteria={onClearCriteria}
          />
        )}
        {props.selectedStatus.length > 0 && (
          <PractitionerConsumptionItemFilterComponent
            criteriaName="Estado"
            criteria={props.selectedStatus.map((s) => s.Name || s.id)}
            onClearCriteria={onClearCriteria}
          />
        )}
        {props.selectedDateRange[0] && (
          <PractitionerConsumptionItemFilterComponent
            criteriaName="Fecha desde"
            criteria={[props.selectedDateRange[0].toLocaleDateString()]}
            onClearCriteria={onClearCriteria}
          />
        )}
        {props.selectedDateRange[1] && (
          <PractitionerConsumptionItemFilterComponent
            criteriaName="Fecha hasta"
            criteria={[props.selectedDateRange[1].toLocaleDateString()]}
            onClearCriteria={onClearCriteria}
          />
        )}
        <Button appearance="subtle" shape="circular" onClick={() => setIsOpen(true)}>
          Agregar filtro
        </Button>
      </div>
      {isOpen && (
        <PractitionerFilterPanelComponent
          isOpen={isOpen}
          Filters={filterProps}
          onClose={() => setIsOpen(false)}
          onFilterChange={({
            FilterText,
            SelectedProtocols,
            SelectedCurrencys,
            SelectedStatus,
            SelectedDateRange
          }: IConsumptionsFilters) => {
            props.setFilterText(FilterText);
            props.setSelectedProtocols(SelectedProtocols);
            props.setSelectedCurrency(SelectedCurrencys);
            props.setSelectedStatus(SelectedStatus);
            props.setSelectedDateRange(SelectedDateRange);
          }}
        />
      )}
    </div>
  );
};

export default PractitionerConsumptionFilterComponent;
